import enLocale from 'element-ui/lib/locale/lang/en'

export default {
  ...enLocale,
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    upload: 'Upload',
    download: 'Download',
    export: 'Export',
    import: 'Import',
    operation: 'Operation',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    name: 'Name',
    description: 'Description',
    id: 'ID',
    default: 'Default',
    yes: 'Yes',
    no: 'No',
    loading: 'Loading...',
    modelLoading: 'Loading model...',
    vrmModelLoading: 'Loading VRM model...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Info',
    prevStep: 'Previous',
    nextStep: 'Next'
  },
  systemRole: {
    title: 'System Role Settings',
    selectGroup: 'Please select a group',
    addRole: 'Add Role',
    editRole: 'Edit Role',
    unnamedRole: 'Unnamed Role',
    modelPreviewNotSupported: 'Model preview not supported',
    noModelUploaded: 'No model uploaded',
    uploadModel: 'Upload Model',
    deleteRole: 'Delete Role',
    confirmDelete: 'Are you sure to delete this role?',
    confirmDeleteTitle: 'Tip',
    roleName: 'Role Name',
    roleDescription: 'Role Description',
    selectModel: 'Select Model',
    modelFormat: 'Model Format',
    avatar: 'Avatar',
    uploadAvatar: 'Upload Avatar',
    isDefault: 'Set as Default',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    language: 'Language',
    speechRate: 'Speech Rate',
    pitchRate: 'Pitch Rate',
    volume: 'Volume',
    voice: 'Voice',
    defaultVoice: 'Default Voice',
    characterBackground: 'Character Background (Prompt)',
    noPrompt: 'No prompt',
    noSystemRoles: 'No system roles',
    clickToUpload: 'Click to Upload',
    clickToUploadAvatar: 'Click to Upload Avatar',
    avatarUploadTip: 'Supports JPG, PNG format, file size not exceeding 2MB',
    name: 'Name',
    namePlaceholder: 'Optional',
    prompt: 'Prompt',
    promptPlaceholder: 'System prompt',
    voicePlaceholder: 'e.g. female_1',
    languagePlaceholder: 'e.g. zh-CN',
    inputNumberError: 'Please enter a number',
    getGroupListFailed: 'Failed to get group list',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    unknownError: 'Unknown error',
    deleteSuccess: 'Delete successful',
    setDefaultSuccess: 'Set as default',
    selectModelFile: 'Please select a model file to upload',
    modelUploadSuccess: 'Model upload successful',
    modelUploadFailed: 'Model upload failed',
    convertingPmx: 'Converting model, please wait...',
    conversionFailed: 'Model conversion failed',
    conversionTimeout: 'Model conversion timeout, please try again',
    avatarFormatError: 'Avatar image must be JPG/PNG format!',
    avatarSizeError: 'Avatar image size cannot exceed 2MB!',
    avatarUploadSuccess: 'Avatar upload successful',
    avatarUploadFailed: 'Avatar upload failed',
    avatarLoadFailed: 'Avatar image load failed, please upload again',
    modelLoadFailed: 'Model load failed, please try again',
    reuploadModel: 'Re-upload',
    enableModelPreview: 'Enable Model Preview',
    domestic: 'Domestic',
    international: 'Overseas'
  },
  system: {
    paramManagement: 'System Parameter Management',
    limitConfig: 'Limit Configuration',
    asrDurationLimit: 'ASR Duration Limit',
    asrDurationLimitDesc: 'Maximum duration limit for single ASR (speech recognition) usage',
    milliseconds: 'milliseconds',
    appDownloadUrl: 'Client APP Download URL',
    uploadApp: 'Upload APP',
    llmTokenLimit: 'LLM Token Limit',
    ttsTokenLimit: 'TTS Token Limit',
    ttsTokenLimitDesc: 'Maximum token limit for single TTS (text-to-speech) usage',
    llmTokenLimitDesc: 'Maximum token limit for single LLM (large language model) usage',
    limitValidPeriodHours: 'Limit Validity Period',
    limitValidPeriodHoursDesc: 'Usage records within this time period are counted towards the limit',
    tokenCount: 'Token Count',
    hours: 'hours',
    saveSettings: 'Save Settings',
    uploadAfterAutoGenerate: 'Download URL will be generated automatically after upload',
    systemPrompt: 'systemPrompt',
    addLanguageFormat: 'Add',
    editLanguageFormat: 'Edit',
    languageCode: 'Code',
    languageName: 'Name',
    prompt: 'prompt',
    systemPromptTemplate: 'System Prompt Template',
    languageCodePlaceholder: 'Please enter language code (e.g., en, zh, yue, ja)',
    languageCodeDesc: 'Usually ISO 639-1 two-letter lowercase (e.g. en, zh, ja). Cantonese matches character/TTS: use yue.',
    languageNamePlaceholder: 'Please enter language name (e.g., English, Chinese, Japanese)',
    promptPlaceholder: 'Please enter prompt content, supports multi-line text, use \\n for line breaks',
    promptDesc: 'Prompt content, used to guide AI character behavior norms',
    systemPromptTemplatePlaceholder: 'Please enter system prompt template, must include %s placeholder (for replacing location information)',
    systemPromptTemplateDesc: 'System prompt template format suggestion: LANGUAGE: {language code}\\nLOCATION: %s\\nMAX_TOKENS: 2000',
    // 验证错误提示
    validationLanguageCodeRequired: 'Please enter language code',
    validationLanguageCodeFormat: 'Must be two lowercase letters or yue (e.g., en, zh, yue, ja)',
    validationLanguageNameRequired: 'Please enter language name',
    validationPromptRequired: 'Please enter prompt',
    validationSystemPromptTemplateRequired: 'Please enter system prompt template',
    validationSystemPromptTemplatePlaceholder: 'System prompt template must include %s placeholder (for replacing location information)',
    imageAgentApiKey: 'Image Agent API Key',
    imageAgentModel: 'Image Agent Model',
    version: 'Version',
    versionPlaceholder: 'Please enter version',
    catalogSize: 'Catalog Size',
    catalogHash: 'Catalog Hash',
    catalogHashPlaceholder: 'Please enter catalog hash',
    catalogUrl: 'Catalog URL',
    catalogUrlPlaceholder: 'Please enter catalog URL',
    bytes: 'Bytes',
    toolAgentApiKey: 'Tool Agent API Key',
    toolAgentApiKeyPlaceholder: 'Please enter tool agent API key',
    toolAgentModel: 'Tool Agent Model',
    toolAgentModelPlaceholder: 'Please enter tool agent model',
    actionAgentApiKey: 'Action Agent API Key',
    actionAgentApiKeyPlaceholder: 'Please enter action agent API key',
    actionAgentModel: 'Action Agent Model',
    actionAgentModelPlaceholder: 'Please enter action agent model',
    qwenConfig: 'Qwen Configuration',
    qwenApiKey: 'Qwen API Key',
    qwenApiKeyPlaceholder: 'Please enter Qwen API key',
    qwenApiUrl: 'Qwen API URL',
    qwenApiUrlPlaceholder: 'Please enter Qwen API URL',
    qwenModel: 'Qwen Model',
    qwenModelPlaceholder: 'Please enter Qwen model',
    qwenTtsApiKey: 'Qwen TTS API Key',
    qwenTtsApiKeyPlaceholder: 'Please enter Qwen TTS API key',
    qwenTtsModel: 'Qwen TTS Model',
    qwenTtsModelPlaceholder: 'Please enter Qwen TTS model',
    qwenAsrApiKey: 'Qwen ASR API Key',
    qwenAsrApiKeyPlaceholder: 'Please enter Qwen ASR API key',
    qwenAsrModel: 'Qwen ASR Model',
    qwenAsrModelPlaceholder: 'Please enter Qwen ASR model',
    ttskey: 'Clone Voice TTS API Key',
    ttskeyPlaceholder: 'Please enter Clone Voice TTS API Key',
    ttsmodel: 'Clone Voice TTS Model',
    ttsmodelPlaceholder: 'Please enter Clone Voice TTS Model',
    environment: 'Environment',
    environmentDomestic: 'Domestic',
    environmentOverseas: 'Overseas',
    environmentUnknown: 'Unknown'
  },
  home: {
    home: 'Home',
    modelCommunity: 'Model Community',
    creationCenter: 'Creation Center',
    createNewCharacter: 'Create New Character',
    myRoleLibrary: 'My Role Library',
    myFriends: 'My Friends',
    llmModel: 'Hot Word Setting',
    voiceSettings: 'Voice Settings',
    myVoiceLibrary: 'My Voice Library',
    roomDesign: 'Room Design',
    actionLibrary: 'Action Library',
    systemRoleSettings: 'System Role Settings',
    voiceSettings: 'Voice Cloning',
    systemParam: 'System Parameters',
    usageLog: 'Usage Log',
    timePlanMenu: 'Time Plans',
    promptMenu: 'Prompt Templates',
    behaviorRuleMenu: 'Behavior Rules',
    usagePlanMenu: 'Usage Plans',
    deviceInfoMenu: 'Device Info',
    userManageMenu: 'Users',
    orderManageMenu: 'Orders',
    activationCodeMenu: 'Activation Codes',
    topicLibraryMenu: 'Topic Library',
    logout: 'Logout',
    aimeeCommunity: 'Amy Community (Beta)',
    community: 'Community',
    contactUs: 'Contact Us'
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'If you encounter any problems during use, or have any comments and suggestions, please feel free to contact us through the following channels.',
    qqGroupTitle: 'Official QQ Group',
    qqGroupDesc: 'Scan the QR code or search for the group number to join our official community, and interact with developers and other users in real time.',
    qqGroupNumber: 'Group ID: 1083324814',
    emailTitle: 'Official Email',
    emailDesc: 'For business cooperation, technical support, or in-depth inquiries, please send an email to our official inbox.',
    emailAddress: 'ai@laplacemate.com',
    emailBtn: 'Send Email',
    copyEmail: 'Copy Email',
    copied: 'Copied',
    discordTitle: 'Official Discord',
    discordDesc: 'Join our official Discord community to connect with other users, ask questions, and get the latest updates.',
    discordUrl: 'https://discord.gg/uMvdyPQgSc',
    discordBtn: 'Join Discord',
    workTimeTitle: 'Service Hours',
    workTimeDesc: 'Monday to Friday 09:00 - 18:00 (GMT+8)'
  },
  login: {
    title: 'User Login',
    codeLogin: 'Code Login',
    passwordLogin: 'Password Login',
    phonePlaceholder: 'Please enter phone number',
    emailPlaceholder: 'Please enter email',
    codePlaceholder: 'Please enter verification code',
    passwordPlaceholder: 'Please enter password',
    getCode: 'Get Code',
    resendAfter: 's to resend',
    login: 'Login',
    forgotPassword: 'Forgot Password',
    register: 'Register',
    phoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number',
    emailRequired: 'Please enter email',
    emailFormatError: 'Please enter a valid email address',
    codeRequired: 'Please enter verification code',
    codeFormatError: 'Please enter 6-digit verification code',
    passwordRequired: 'Please enter password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    codeSent: 'Verification code has been sent, please check',
    codeError: 'Verification code is incorrect or expired, please try again',
    loginSuccess: 'Login successful',
    loginError: 'Phone number or password is incorrect, please try again',
    loginErrorEmail: 'Email or password is incorrect, please try again',
    networkError: 'Network error, please try again later',
    getCodeError: 'Failed to get verification code, please try again'
  },
  forgotPassword: {
    title: 'Forgot Password',
    step1: 'Verify Email',
    step2: 'Reset Password',
    step3: 'Complete',
    emailPlaceholder: 'Please enter registered email',
    sendCode: 'Send Verification Code',
    verifyCodePlaceholder: 'Please enter verification code',
    newPasswordPlaceholder: 'Please enter new password',
    resetPassword: 'Reset Password',
    successTitle: 'Password Reset Successful!',
    successMessage: 'Please login with your new password',
    backToLogin: 'Back to Login',
    emailRequired: 'Please enter email address',
    emailFormatError: 'Please enter a valid email address',
    verifyCodeRequired: 'Please enter verification code',
    verifyCodeLengthError: 'Verification code must be 6 digits',
    newPasswordRequired: 'Please enter new password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    codeSent: 'Verification code has been sent to your email',
    resetSuccess: 'Password reset successful',
    resetError: 'Password reset failed, please try again',
    networkError: 'Network error, please try again later'
  },
  register: {
    title: 'User Register',
    phonePlaceholder: 'Please enter phone number',
    emailPlaceholder: 'Please enter email',
    codePlaceholder: 'Please enter verification code',
    passwordPlaceholder: 'Please enter password',
    confirmPasswordPlaceholder: 'Please confirm password',
    getCode: 'Get Code',
    resendAfter: 's to resend',
    register: 'Register',
    hasAccount: 'Already have an account? Login',
    phoneRequired: 'Please enter phone number',
    phoneFormatError: 'Please enter a valid phone number',
    emailRequired: 'Please enter email',
    emailFormatError: 'Please enter a valid email address',
    codeRequired: 'Please enter verification code',
    codeFormatError: 'Please enter 6-digit verification code',
    passwordRequired: 'Please enter password',
    passwordLengthError: 'Password length should be between 6-20 characters',
    confirmPasswordRequired: 'Please enter password again',
    passwordMismatch: 'Passwords do not match',
    codeSent: 'Verification code has been sent, please check',
    registerSuccess: 'Registration successful, redirecting to login page',
    registerError: 'Registration failed, please try again',
    networkError: 'Network error, please try again later',
    getCodeError: 'Failed to get verification code, please try again'
  },
  voiceSettings: {
    title: 'Voice Cloning',
    voiceList: 'Voice List',
    totalCount: 'Total {count} records',
    voiceId: 'Voice ID',
    voiceName: 'Voice Name',
    model: 'Model Name',
    speechRate: 'Speech Rate',
    pitchRate: 'Pitch Rate',
    voiceType: 'Voice Type',
    systemVoice: 'System Voice',
    customVoice: 'Custom Voice',
    status: 'Status',
    audioFile: 'Audio File',
    play: 'Play',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    loadError: 'Failed to load voice list',
    networkError: 'Network error, please try again later',
    noAudioFile: 'No audio file',
    playError: 'Failed to play audio',
    audioPreview: 'Audio Preview',
    index: 'Index',
    addVoice: 'Add Voice',
    addMethod: 'Add Method',
    addMethodRequired: 'Please select add method',
    uploadAudio: 'Upload Audio',
    uploadAudioDesc: 'Upload local audio file to clone voice',
    manualVoiceId: 'Manual ID',
    manualVoiceIdDesc: 'Enter existing voice ID to bind',
    addVoiceTip: 'Add voice feature is under development...',
    voiceNamePlaceholder: 'Please enter voice name',
    voiceNameRequired: 'Please enter voice name',
    voiceNameMaxLength: 'Voice name cannot exceed 50 characters',
    audioFileRequired: 'Please upload audio file',
    uploaded: 'Uploaded',
    reupload: 'Re-upload',
    audioFormatError: 'Only MP3 and WAV audio formats are supported',
    audioSizeError: 'Audio file size cannot exceed 20MB',
    audioSizeErrorUser: 'Audio file size cannot exceed 20MB',
    uploadDurationHint: 'Recommended audio duration is no longer than {seconds} seconds',
    audioDurationReadFailed: 'Unable to read audio duration, please try another file',
    audioDurationLimitExceeded: 'Audio duration exceeds limit (max {seconds}s), please trim and retry',
    uploadSuccess: 'Audio upload successful',
    uploadFailed: 'Audio upload failed',
    addVoiceSuccess: 'Voice added successfully',
    addVoiceFailed: 'Failed to add voice',
    // Voice Cloning Page
    name: 'Name',
    namePlaceholder: 'Please enter name',
    nameExists: 'Name already exists, please use another name',
    nameRequired: 'Please enter name',
    nameMaxLength: 'Name cannot exceed 50 characters',
    audioFileRequiredForClone: 'Please upload audio file first',
    saveToLibrary: 'Save to Voice Library',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    uploadHint: 'Drag and drop here to upload or click to upload',
    uploadFormatHint: 'Supported formats: MP3, WAV (Max 20MB)',
    pitchRateLabel: 'Pitch',
    speechRateLabel: 'Speech Rate',
    // My Voice Library Page
    myVoiceLibrary: 'My Voice Library',
    operationGuide: 'Operation Guide',
    viewOperationGuide: 'View Operation Guide',
    systemVoiceLibrary: 'System Voice Library',
    index: 'Index',
    voiceName: 'Voice Name',
    category: 'Category',
    gender: 'Gender',
    status: 'Status',
    operation: 'Operation',
    preview: 'Preview',
    stop: 'Stop',
    male: 'Male',
    female: 'Female',
    system: 'System',
    created: 'Created',
    enabled: 'Enabled',
    disabled: 'Disabled',
    unknown: 'Unknown',
    edit: 'Edit',
    delete: 'Delete',
    noVoiceData: 'No voice data',
    audioPreview: 'Audio Preview',
    editVoice: 'Edit Voice',
    previewTextPlaceholder: 'Enter preview text (supports Chinese, English, Japanese, Korean, French, Spanish, Italian, German & punctuation, max 300 chars)',
    voicePreview: 'Voice Preview',
    save: 'Save',
    noSystemVoiceData: 'No system voice data',
    useSystemVoice: 'Use System Voice',
    use: 'Use',
    saveToMyVoiceLibrary: 'Save to My Voice Library',
    previewTextRequired: 'Please enter preview text',
    voiceIdNotExists: 'Voice ID does not exist',
    playAudioFailed: 'Failed to play audio, please check audio format',
    previewFailed: 'Preview failed',
    editSuccess: 'Edit successful',
    editFailed: 'Edit failed',
    deleteConfirm: 'Are you sure you want to delete this voice?',
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    noAudioFile: 'This voice has no audio file',
    getVoiceListFailed: 'Failed to get voice list',
    getSystemVoiceListFailed: 'Failed to get system voice list',
    saveToMyVoiceLibrarySuccess: 'Successfully saved to My Voice Library',
    saveFailed2: 'Save failed',
    prevStep: 'Previous',
    nextStep: 'Next',
    finish: 'Finish',
    welcomeToMyVoiceLibrary: 'Welcome to My Voice Library',
    myVoiceLibraryDescription: 'This is where you manage all your voices. You can view, edit, play and delete voices you created.',
    systemVoiceLibraryDescription: 'Click the "System Voice Library" button in the upper right corner to view voice templates provided by the system.',
    voiceListTitle: 'Voice List',
    voiceListDescription: 'This shows all the voices you created. You can edit, play or delete each voice.',
    operationButtons: 'Operation Buttons',
    operationButtonsDescription: 'Each voice has operation buttons: Edit can modify the voice name, Play can preview the voice effect, Delete can remove unwanted voices.',
    namePlaceholderForEdit: 'Please enter voice name'
  },
  usageLog: {
    title: 'User Usage Records',
    listTitle: 'Usage Record List',
    exportData: 'Export Data',
    userSN: 'User SN',
    userId: 'User ID',
    userSNPlaceholder: 'Please enter user SN',
    timeRange: 'Time Range',
    quickSelect: 'Quick Select',
    quickSelectPlaceholder: 'Quick select time',
    today: 'Today',
    yesterday: 'Yesterday',
    last7days: 'Last 7 Days',
    last30days: 'Last 30 Days',
    thisMonth: 'This Month',
    lastMonth: 'Last Month',
    query: 'Query',
    reset: 'Reset',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'To',
    statistics: 'User Statistics',
    totalAsrDuration: 'Total ASR Duration',
    totalLlmTokens: 'Total LLM Tokens',
    totalTtsTokens: 'Total TTS Tokens',
    totalUsageCount: 'Total Usage Count',
    sn: 'SN',
    usageTime: 'Usage Time',
    asrDuration: 'ASR Duration',
    llmTokens: 'LLM Tokens',
    ttsTokens: 'TTS Tokens',
    usageType: 'Usage Type',
    asr: 'ASR',
    llm: 'LLM',
    tts: 'TTS',
    input: 'Input',
    output: 'Output',
    total: 'Total'
  },
  timePlan: {
    title: 'Time Plan Management',
    add: 'Add plan',
    edit: 'Edit',
    delete: 'Delete',
    name: 'Name',
    originalPrice: 'Original price',
    salePrice: 'Sale price',
    validityPeriod: 'Validity (days)',
    namePlaceholder: 'Plan name',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this time plan?',
    tip: 'Notice',
    nameRequired: 'Name is required',
    validityRequired: 'Validity must be greater than 0'
  },
  promptTemplate: {
    title: 'Prompt Templates',
    add: 'Add Template',
    edit: 'Edit',
    delete: 'Delete',
    templateId: 'Template ID',
    templateName: 'Template Name',
    version: 'Version',
    intent: 'Intent',
    tone: 'Tone',
    riskLevel: 'Risk Level',
    systemPrompt: 'System Prompt',
    templateBody: 'Template Body',
    outputConstraints: 'Output Constraints',
    forbiddenPatterns: 'Forbidden Patterns',
    enabled: 'Enabled',
    yes: 'Yes',
    no: 'No',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this prompt template?',
    tip: 'Confirm',
    templateIdRequired: 'Template ID is required',
    templateNameRequired: 'Template name is required',
    versionRequired: 'Version is required',
    intentRequired: 'Intent is required',
    systemPromptRequired: 'System prompt is required',
    templateBodyRequired: 'Template body is required'
  },
  behaviorRule: {
    title: 'Behavior Rules',
    add: 'Add Rule',
    edit: 'Edit',
    delete: 'Delete',
    ruleCode: 'Rule Code',
    ruleName: 'Rule Name',
    conditionDescription: 'Condition Description',
    priority: 'Priority',
    conditionExpr: 'Condition Expression',
    targetRole: 'Target Role',
    presenceState: 'Presence State',
    timePeriod: 'Time Period',
    timeWindow: 'Time Window',
    userBehavior: 'User Behavior',
    visualState: 'Visual State',
    cooldownType: 'Cooldown Type',
    cooldownValue: 'Cooldown Range',
    cooldownScope: 'Cooldown Scope',
    executor: 'Executor',
    templateId: 'Template ID',
    templateName: 'Template Name',
    templateIdPlaceholder: 'Select a prompt template',
    contextSources: 'Context Sources',
    tabBasic: 'Basic',
    tabMatch: 'Match Conditions',
    tabExecute: 'Cooldown & Execute',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this behavior rule?',
    tip: 'Confirm',
    ruleCodeRequired: 'Rule code is required',
    ruleNameRequired: 'Rule name is required',
    conditionDescriptionRequired: 'Condition description is required',
    cooldownTypeRequired: 'Cooldown type is required',
    cooldownValueRequired: 'Cooldown range is required',
    cooldownScopeRequired: 'Cooldown scope is required',
    executorRequired: 'Executor is required',
    contextSourcesRequired: 'Context sources JSON is required',
    templateIdRequired: 'Template ID is required'
  },
  usagePlan: {
    title: 'Usage plan (tier)',
    cardNormal: 'Standard',
    cardVip: 'VIP',
    emptySlot: 'No plan row. Add records in the plan table first.',
    edit: 'Edit',
    name: 'Tier name',
    asrDurationLimit: 'ASR duration cap',
    ttsTokenLimit: 'TTS token cap',
    llmTokenLimit: 'LLM token cap',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    createTime: 'Created',
    updateTime: 'Updated',
    namePlaceholder: 'Tier name',
    operation: 'Actions',
    asrMsHint: 'Unit: milliseconds (ms)',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    nameRequired: 'Name is required',
    asrRequired: 'ASR duration cap is required',
    ttsRequired: 'TTS token cap is required',
    llmRequired: 'LLM token cap is required',
    statusRequired: 'Status is required'
  },
  customBackground: {
    title: 'Custom Backgrounds',
    add: 'Upload background',
    edit: 'Edit',
    delete: 'Delete',
    name: 'Name',
    namePlaceholder: 'Enter a custom name',
    file: 'Background file',
    preview: 'Preview',
    apply: 'Apply',
    mediaType: 'Type',
    image: 'Image',
    video: 'Video',
    empty: 'No custom backgrounds yet. Upload an image or video to get started.',
    uploadTip: 'Click to upload',
    reupload: 'Re-upload',
    uploadHint: 'PNG, JPG, JPEG, MP4. Images up to 10MB, videos up to 10MB',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    uploadSuccess: 'Uploaded',
    uploadError: 'Upload failed',
    applySuccess: 'Applied background "{name}"',
    confirmDelete: 'Delete this custom background?',
    tip: 'Notice',
    nameRequired: 'Name is required',
    fileRequired: 'Please upload a background file',
    formatError: 'Only PNG, JPG, JPEG, MP4 are supported',
    sizeError: 'File size must not exceed {size}MB'
  },
  deviceInfo: {
    title: 'Device Information',
    add: 'Add device',
    edit: 'Edit',
    delete: 'Delete',
    deviceSn: 'Device SN',
    deviceSys: 'OS',
    deviceType: 'Device type',
    deviceInfoJson: 'Device JSON',
    deviceSnPlaceholder: 'Serial number',
    deviceSysPlaceholder: 'e.g. Android / iOS',
    deviceTypePlaceholder: 'Model or type',
    jsonPlaceholder: 'Optional full JSON',
    createTime: 'Created',
    updateTime: 'Updated',
    operation: 'Actions',
    loadError: 'Failed to load list',
    saveSuccess: 'Saved',
    deleteSuccess: 'Deleted',
    confirmDelete: 'Delete this device record?',
    tip: 'Notice',
    snRequired: 'Device SN is required'
  },
  userManage: {
    title: 'Platform users',
    userId: 'User ID',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Search nickname',
    phone: 'Phone',
    phonePlaceholder: 'Search phone',
    email: 'Email',
    emailPlaceholder: 'Search email',
    deviceSn: 'Device SN',
    status: 'Status',
    source: 'Source',
    planId: 'Usage plan',
    planTierColumn: 'Plan',
    planTierFilter: 'Plan',
    planTierNormal: 'Normal',
    planTierVip: 'VIP',
    vipStartTime: 'VIP start',
    vipEndTime: 'VIP expires',
    planPlaceholder: 'Select plan',
    query: 'Search',
    reset: 'Reset',
    all: 'All',
    createTime: 'Registered',
    operation: 'Actions',
    edit: 'Edit',
    recharge: 'Top up',
    rechargeTitle: 'Add subscription time',
    rechargeUser: 'User',
    customDays: 'Days',
    customDaysPlaceholder: 'Number of days',
    customDaysHint: '1–3650 days',
    customDaysRequired: 'Enter a valid number of days',
    customDaysTooLarge: 'Maximum 3650 days per top-up',
    rechargeSuccess: 'Success. Subscription valid until: {end}',
    loadError: 'Failed to load',
    saveSuccess: 'Saved',
    statusNormal: 'Active',
    statusDisabled: 'Disabled',
    sourceWeb: 'Web',
    sourceMp: 'Mini program',
    gender: 'Gender',
    genderPlaceholder: 'Optional',
    genderFemale: 'Female',
    genderMale: 'Male',
    birthday: 'Birthday',
    birthdayPlaceholder: 'Optional',
    nicknameRequired: 'Nickname is required',
    statusRequired: 'Status is required'
  },
  orderManage: {
    title: 'Platform orders',
    id: 'Order ID',
    orderNo: 'Order no.',
    orderNoPlaceholder: 'Search order no.',
    userId: 'User ID',
    userIdPlaceholder: 'Exact ID',
    userName: 'Nickname',
    userNamePlaceholder: 'Search nickname',
    status: 'Status',
    type: 'Type',
    amount: 'Amount',
    paidAmount: 'Paid',
    timePlanName: 'Time plan',
    planId: 'Usage Plan ID',
    timePlanId: 'Time Plan ID',
    createTime: 'Created',
    payTime: 'Paid at',
    startTime: 'Benefit start',
    endTime: 'Benefit end',
    createTimeRange: 'Created',
    to: 'to',
    startDate: 'Start',
    endDate: 'End',
    query: 'Search',
    reset: 'Reset',
    all: 'All',
    statusPending: 'Pending',
    statusActive: 'Active',
    statusDone: 'Completed',
    statusCancelled: 'Cancelled',
    typeMember: 'Membership',
    typeGoods: 'Goods',
    typeRecharge: 'Top-up',
    loadError: 'Failed to load list'
  },
  activationCode: {
    title: 'Activation Codes',
    generateTitle: 'Generate Code',
    taobaoOrderNo: 'Taobao Order No.',
    taobaoOrderNoPlaceholder: 'Enter Taobao order number',
    taobaoOrderNoRequired: 'Taobao order number is required',
    productType: 'Product Type',
    productVip: 'VIP',
    productCamera: 'Camera',
    remark: 'Remark',
    remarkPlaceholder: 'Optional',
    generate: 'Generate',
    code: 'Code',
    codePlaceholder: 'Search',
    status: 'Status',
    statusUnused: 'Unused',
    statusUsed: 'Used',
    statusRevoked: 'Revoked',
    usedUserId: 'User ID',
    usedUserIdPlaceholder: 'Exact',
    usedUserName: 'User',
    usedUserNamePlaceholder: 'Search nickname',
    usedAt: 'Redeemed At',
    usedDeviceSn: 'Device SN',
    createdByName: 'Created By',
    createTime: 'Created At',
    createTimeRange: 'Created At',
    operation: 'Actions',
    copy: 'Copy',
    revoke: 'Revoke',
    revokeConfirm: 'Revoke this unused code? This cannot be undone.',
    revokeSuccess: 'Revoked',
    revokeError: 'Revoke failed',
    query: 'Search',
    reset: 'Reset',
    all: 'All',
    to: 'to',
    startDate: 'Start',
    endDate: 'End',
    close: 'Close',
    generateSuccessTitle: 'Code Generated',
    generateSuccessTip: 'Send this code to the customer. They can redeem it after logging in on their device.',
    generateError: 'Generation failed',
    loadError: 'Failed to load list',
    copySuccess: 'Copied to clipboard',
    copyError: 'Copy failed'
  },
  dashboard: {
    title: 'Dashboard',
    totalUsers: 'Total Users',
    totalOrders: 'Total Orders',
    sales: 'Sales',
    messages: 'Messages'
  },
  createRole: {
    name: 'Name',
    namePlaceholder: 'Please enter name',
    gender: 'Gender',
    selectGender: 'Select gender',
    genderFemale: 'Female',
    genderMale: 'Male',
    genderPreferNotToSay: 'Prefer not to say',
    genderRequired: 'Please select gender',
    characterBackground: 'Character Background (Prompt)',
    promptPlaceholder: 'Please enter prompt',
    characterVoice: 'Character Voice',
    selectVoice: 'Select character voice',
    setVoice: 'Set Voice',
    wakeWord: 'Wake Word',
    selectWakeWord: 'Select wake word',
    setWakeWord: 'Set Wake Word',
    characterModel: 'Character Model',
    uploaded: 'Uploaded',
    reupload: 'Re-upload',
    dragOrClick: 'Drag and drop here or click to upload',
    modelPreview: 'Model Preview',
    uploadYourModel: 'Upload your model',
    saveToLibrary: 'Save to Library',
    apply: 'Apply',
    youngMale: 'Young Male',
    youngFemale: 'Young Female',
    middleMale: 'Middle Male',
    middleFemale: 'Middle Female',
    missingModelId: 'Missing model ID',
    loadEditDataSuccess: 'Edit data loaded',
    loadFailed: 'Load failed',
    networkError: 'Network error',
    modelLoadFailed: 'Model load failed, please try again',
    uploadModelError: 'Please upload .fbx, .vrm, .zip, .rar, .7z format model files',
    modelLoaded: 'Local model loaded: {name}',
    nameRequired: 'Please enter character name',
    nameMaxLength: 'Character name cannot exceed 10 characters',
    promptRequired: 'Please enter character background (prompt)',
    promptMaxLength: 'Prompt cannot exceed 1000 characters',
    voiceRequired: 'Please select character voice',
    wakeWordRequired: 'Please select wake word',
    modelFileRequired: 'Please select and upload model file first',
    createSuccess: 'Character created successfully!',
    createFailed: 'Creation failed, please try again later',
    operationFailed: 'Operation failed, please check network or try again later',
    language: 'Language',
    forcedOutputLanguage: 'Forced output language',
    selectLanguage: 'Please select language',
    selectForcedOutputLanguage: 'Optional; leave empty for no constraint',
    forcedOutputLanguageYueVoiceHint: 'This is a Cantonese voice; speech output must be Cantonese.',
    languageRequired: 'Please select language',
    languageChinese: 'Chinese',
    languageJapanese: 'Japanese',
    languageKorean: 'Korean',
    languageEnglish: 'English',
    languageFrench: 'French',
    languageSpanish: 'Spanish',
    languageItalian: 'Italian',
    languageGerman: 'German',
    languageCantonese: 'Cantonese'
  },
  myModels: {
    completed: 'Completed',
    modelPreviewNotSupported: 'Model preview not supported',
    characterVoice: 'Character Voice',
    defaultVoice: 'Default Voice',
    format: 'Format',
    characterBackground: 'Character Background (Prompt)',
    chatLog: 'Chat Log (Long-term Memory)',
    edit: 'Edit',
    apply: 'Apply',
    noModels: 'No models, please upload a new model.',
    getListFailed: 'Failed to get model list',
    deleteConfirmTitle: 'Warning',
    deleteConfirmMessage: 'Are you sure you want to delete this role? This action cannot be undone.',
    confirmDelete: 'Confirm',
    cancelDelete: 'Cancel',
    deleteSuccess: 'Role deleted successfully',
    deleteFailed: 'Failed to delete role'
  },
  voiceModels: {
    languageSettings: 'Character Language Settings',
    maxResponseLength: 'Maximum Response Length',
    briefDescription: 'Brief Description (20 words)',
    detailedDescription: 'Detailed Description (100 words)',
    responseSpeed: 'Response Speed',
    fast: 'Fast',
    normal: 'Normal',
    slow: 'Slow',
    hotWordSettings: 'Hot Word Settings',
    wakeWord: 'Wake Word',
    wakeWordPlaceholder: 'Hello Amy',
    interruptConversation: 'Interrupt Conversation',
    interruptPlaceholder: 'Interrupt',
    endConversation: 'End Conversation',
    endPlaceholder: 'Goodbye',
    specialPhrase: 'Special Phrase Recognition',
    specialPhrasePlaceholder: 'Super League',
    specialPhraseDefault: 'Naruto',
    add: 'Add',
    hotWordLibrary: 'Hot Word Library',
    sequence: 'No.',
    hotWord: 'Hot Word',
    category: 'Category',
    operation: 'Operation',
    delete: 'Delete',
    confirmDeleteHotWord: 'Are you sure you want to delete this hot word?',
    confirmDeleteTitle: 'Confirm',
    deleteSuccess: 'Deleted successfully',
    deleteFailed: 'Delete failed',
    addSuccess: 'Added successfully',
    addFailed: 'Add failed',
    loadError: 'Failed to load hot words',
    endConversationRequired: 'Please enter an end conversation hot word',
    specialPhraseRequired: 'Please enter a special phrase hot word'
  },
  voiceSetting: {
    createVoice: 'Create Voice',
    name: 'Name',
    namePlaceholder: 'Amy Voice',
    pitch: 'Pitch',
    speechRate: 'Speech Rate',
    gender: 'Gender',
    female: 'Female',
    male: 'Male',
    sampleText: 'Sample Text',
    sampleTextPlaceholder: 'Sample Text',
    voicePreview: 'Voice Preview',
    saveToVoiceLibrary: 'Save to Voice Library',
    cloneVoice: 'Clone Voice',
    cloneNamePlaceholder: 'Hello Amy',
    dragOrClick: 'Drag and drop here or click to upload',
    voiceLibrary: 'Voice Library',
    sequence: 'No.',
    voice: 'Voice',
    category: 'Category',
    operation: 'Operation',
    edit: 'Edit',
    delete: 'Delete'
  },
  topicLibrary: {
    title: 'Topic Library Management',
    add: 'Add Topic',
    edit: 'Edit Topic',
    delete: 'Delete Topic',
    batchDelete: 'Batch Delete',
    batchImport: 'Batch Import',
    basicSettings: 'Basic Properties',
    matchingScenes: 'Trigger Scenarios / Conditions',
    topicText: 'Topic Text',
    topicTextSearchPlaceholder: 'Fuzzy search topic text',
    moodTag: 'Mood Tag',
    interactionLevel: 'Interaction Depth',
    contextTags: 'Scene Tags',
    weatherTags: 'Weather',
    timePeriodTags: 'Time Period',
    workdayTags: 'Workday',
    peopleTags: 'People',
    seasonTags: 'Season',
    anniversaryTags: 'Anniversary',
    tagAllHint: 'ALL matches any condition for this dimension',
    topicWeight: 'Topic Weight',
    repeatCooldown: 'Cooldown',
    enabled: 'Enabled Status',
    yes: 'Yes',
    no: 'No',
    operation: 'Operation',
    loadError: 'Failed to load topic list',
    saveSuccess: 'Saved successfully',
    deleteSuccess: 'Deleted successfully',
    confirmDelete: 'Are you sure to delete this topic?',
    confirmBatchDelete: 'Are you sure to delete the selected {count} topics?',
    tip: 'Tip',
    topicTextRequired: 'Please enter topic text',
    interactionLevelRequired: 'Please select interaction level',
    topicWeightRequired: 'Please enter topic weight',
    enabledRequired: 'Please select enabled status',
    importTitle: 'Batch Import Topics',
    importFormatTip: 'Paste CSV / JSON text, or upload a CSV / Excel file. For multi-value dimensions, separate with commas and wrap in quotes, e.g. "SUNNY,CLOUDY"; leave empty or use ALL for any.',
    csvTemplate: 'CSV Format Example:\nTopic Text,Mood Tag,Interaction Level,Weather,Time Period,Workday,People,Season,Anniversary,Topic Weight,Cooldown,Enabled\nE.g.:\nIt is a nice day today,LIGHT_CHAT,1,SUNNY,ALL,ALL,ALL,ALL,ALL,0.5,7d,true',
    importPlaceholder: 'Paste CSV or JSON data here...',
    fileUploadBtn: 'Choose CSV / Excel File',
    importSuccess: 'Successfully imported {count} topics',
    importFailed: 'Import failed',
    downloadCsvTemplate: 'Download CSV Template',
    downloadXlsxTemplate: 'Download Excel Template',
    downloadJsonExample: 'Download JSON Example'
  }
}

